<ng-container *ngIf="!isDesktop else desktop">
    <div *ngIf="missionsIndex>-1" class="missions-container" (click)="openMissionsDialog()">
        <img src="{{licenceService.getKey('icon-mission-home')}}" />
    </div>
</ng-container>
<ng-template #desktop>
    <div *ngIf="missionsIndex>-1" class="leaderboard" (click)="openMissionsDialog()">
        <img src="{{licenceService.getKey('icon-mission-home')}}">
        <span i18n>Mission</span>
    </div>
</ng-template>
